module.exports = __webpack_public_path__ + "static/media/021.0fe5f80e.jpg";